
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-green-800 to-green-900 text-white py-8 md:py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-6 md:mb-8">
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Agubel
            </h3>
            <p className="text-xs md:text-base text-green-100 leading-relaxed">
              Associação Gestora da Usina de Beneficiamento de Lácteos, produzindo qualidade e tradição desde 2004.
            </p>
          </div>
          
          <div>
            <h4 className="text-sm md:text-lg font-bold mb-3 md:mb-4">Links Rápidos</h4>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <a href="#sobre" className="text-xs md:text-base text-green-100 hover:text-amber-400 transition-colors cursor-pointer">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#historia" className="text-xs md:text-base text-green-100 hover:text-amber-400 transition-colors cursor-pointer">
                  Nossa História
                </a>
              </li>
              <li>
                <a href="#produtos" className="text-xs md:text-base text-green-100 hover:text-amber-400 transition-colors cursor-pointer">
                  Produtos
                </a>
              </li>
              <li>
                <a href="#premiacoes" className="text-xs md:text-base text-green-100 hover:text-amber-400 transition-colors cursor-pointer">
                  Premiações
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sm md:text-lg font-bold mb-3 md:mb-4">Contato</h4>
            <ul className="space-y-1 md:space-y-2 text-green-100">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 text-xs md:text-base"></i>
                <span className="text-xs md:text-base">Fazenda Agreste, Sumé - PB</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 text-xs md:text-base"></i>
                <a href="tel:+5583999845954" className="text-xs md:text-base hover:text-amber-400 transition-colors cursor-pointer">
                  (83) 99984-5954
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-shield-check-line mr-2 text-xs md:text-base"></i>
                <span className="text-xs md:text-base">Registro SIF</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sm md:text-lg font-bold mb-3 md:mb-4">Redes Sociais</h4>
            <div className="flex space-x-3 md:space-x-4">
              <a
                href="https://instagram.com/laticinio_agubel"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 bg-green-700 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base md:text-xl"></i>
              </a>
              <a
                href="https://facebook.com/laticinoagubel"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 bg-green-700 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-box-line text-base md:text-xl"></i>
              </a>
              <a
                href="https://wa.me/5583999845954"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 bg-green-700 hover:bg-amber-500 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base md:text-xl"></i>
              </a>
            </div>
            <div className="mt-4 md:mt-6">
              <p className="text-green-100 text-xs mb-2">Certificações:</p>
              <div className="flex items-center space-x-2">
                <div className="bg-white text-green-800 px-2 py-1 rounded text-xs font-bold">
                  SIF
                </div>
                <div className="bg-amber-500 text-white px-2 py-1 rounded text-xs font-bold">
                  Premiado
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-green-700 pt-6 md:pt-8 text-center text-green-100">
          <p className="text-xs md:text-base mb-2">
            &copy; {currentYear} Agubel - Laticínio. Todos os direitos reservados.
          </p>
          <p className="text-xs md:text-sm">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-amber-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
